import React from 'react';
import { Control } from 'react-hook-form';
import { Inputs } from '../../../../containers/facilityLotteryReservationForm/facilityLotteryReservationFormService';
import { PostDecodeMstDto } from '../../../../dataAccess/webApi/dto/decodeMstDto';
import SelectBoxField from "./common/selectBoxField"
import { translate } from '../../../../i18n';

export interface UseReasonFieldProps {
    options?: PostDecodeMstDto[]
    required: boolean
    control: Control<Inputs>
}

const maxLength = 100

const UseReasonField: React.FC<UseReasonFieldProps> = (props) => {
    const { options, required, control } = props;
    
    const showOtherSelection = ['その他'];
    
    return (
        <SelectBoxField 
            title={"facilityReservationForm.form.label.formUseReason.field"}
            name={`formUseReason`}
            selectLabel={"facilityReservationForm.form.label.formUseReason.field"}
            otherTitle={translate("facilityReservationForm.form.label.formUseReason.other", maxLength.toString())}
            otherLabel={translate("facilityReservationForm.form.label.formUseReason.other", maxLength.toString())}
            required={required}
            control={control}
            options={options}
            showOtherSelection={showOtherSelection}
            addUnselected
        />
    )
    
}
export default UseReasonField;
